import classNames from 'classnames';
import React from 'react';

const Lobby = ({className, ...props}: React.HTMLProps<HTMLDivElement>) => <div className={classNames('Lobby', className)} {...props} />;

export default Lobby;
